import Form from "./form";
import { AttendanceLocal } from "../../../../../../../../../../../@types/attendance-local";
import { AttendanceLocalDepartment } from "../../../../../../../../../../../@types/attendance-local-department";
import { AttendanceLocalDepartmentGuiche } from "../../../../../../../../../../../@types/attendance-local-department-guiche";
import { useAttendanceLocalDepartmentGuicheUpdate } from "../../../../../../../../../../../services/api-tansquery/attendance-local/department/guiche/update";

type FormUpdateProps = {
    departmentId: AttendanceLocalDepartment["id"];
    slug: AttendanceLocal["slug_unidade"];
    guiche: AttendanceLocalDepartmentGuiche;
    buttonTrigger?: React.ReactNode;
};

export default function FormUpdate(props: FormUpdateProps) {
    const mutation = useAttendanceLocalDepartmentGuicheUpdate(props.guiche.id);

    return (
        <Form
            {...props}
            mutation={mutation}
        />
    );
}
